export const kitchenListFR: string[] = [
  "Faire des truffes au chocolat maison",
  "Préparer des cupcakes de Noël",
  "Réaliser des brochettes de fruits enrobés de chocolat",
  "Concocter une soupe de potiron épicée",
  "Biscuits de gingembre et cannelle décorés",
  "Vin chaud épicé",
  "Truffes au chocolat blanc et canneberges",
  "Sablés de Noël",
  "Limonade de Noël à la canne à sucre et aux épices",
  "Punch de Noël aux fruits",
  "Petits puddings de Noël individuels",
  "Chocolats chauds (optionnel: aromatisés à la menthe poivrée)",
  "Tartelettes aux pommes et cannelle",
  "Smoothie bowl de Noël avec des fruits rouges et granola",
  "Gâteau roulé à la confiture de cranberries",
  "Thé de Noël aux épices (masalai chai)",
  "Cocktail de jus de pomme chaud",
  "Pain d'épices moelleux",
  "Mousse au chocolat et à la menthe",
  "Chocolats fourrés à la pâte d'amande",
  "Punch de cidre chaud",
  "Biscuits étoiles à la cannelle",
  "Cocktail de Noël sans alcool (mocktail) festif",
  "Faire des s’mores",
  "Faire une soirée crèpes de Noël",
];

export const outingsListFR: string[] = [
  "Participer à un atelier de décoration de biscuits de Noël",
  "Regarder un classique de Noël en famille (film ou dessin animé)",
  "Organiser une soirée jeux de société spéciale Noël",
  "Faire une séance de décoration de sapin en musique et avec des guirlandes lumineuses",
  "Écrire des lettres au Père Noël et les poster",
  "Faire une soirée pyjama en regardant des photos ou vidéos de Noëls passés",
  "Prendre une photo avec un Père Noël",
  "Préparer une playlist de chansons de Noël et organiser une séance de karaoké à la maison",
  "Faire une randonnée nocturne pour admirer les lumières de Noël dans le quartier",
  "Préparer des paquets cadeaux personnalisés avec du papier et des rubans originaux",
  "Faire un puzzle de Noël en famille",
  "Acheter un ticket à gratter (spécial Noël)",
  "Organiser un échange de cadeaux 'Secret Santa'",
  "Participer à une collecte de jouets",
  "Réserver ou aller voir un spectacle de Noël",
  "Fabriquer des couronnes de Noël avec des branches et des décorations naturelles",
  "Faire du patin à glace dans une patinoire extérieure ou intérieure",
  "Aller voir un film au cinéma",
  "Préparer et distribuer des biscuits faits maison aux voisins",
  "Faire une soirée conte de Noël en racontant des histoires autour du feu ou sous un plaid",
  "Organiser un repas thématique de Noël avec des plats traditionnels",
  "Faire une session photo déguisée en lutins ou en rennes",
  "Assister à une messe ou à un concert de chants de Noël",
  "Aller visiter un marché de Noël",
  "Créer un scrapbook ou un album photo des fêtes de Noël",
];

export const moviesListFR: string[] = [
  "La Reine des Neiges",
  "Klaus (ou aussi connu sous le titre 'La Légende de Klaus')",
  "Maman, j'ai raté l'avion",
  "Le bonhomme de neige (The Snowman)",
  "Love Actually",
  "The Holiday",
  "Le lutin (Elf)",
  "L'étrange Noël de Mr. Jack",
  "Les chroniques de Noël",
  "Le Grinch",
  "Noël chez les Muppets",
  "La Belle et la Bête: Un Noël enchanté",
  "La magie de Noël (The Family Stone)",
  "Le Noël de Mickey",
  "Le Drôle de Noël de Scrooge",
  "La Légende de Manolo",
  "La princesse des glaces",
  "Le Manoir magique",
  "L'étoile de Noël",
  "La bataille géante de boules de neige",
  "Petit Vampire",
  "Le voyage du Père Noël",
  "Coco",
  "Miracle sur la 34e rue",
  "La course au jouet",
];

export const craftsListFR: string[] = [
  "Fabriquer des décorations en papier pour le sapin de Noël",
  "Créer des cartes de vœux personnalisées à envoyer à la famille et aux amis",
  "Confectionner des ornements en pâte à sel pour décorer la maison",
  "Ecrire le menu de Noël",
  "Fabriquer des bougies parfumées pour créer une ambiance chaleureuse",
  "Créer un calendrier de l'avent fait maison avec des petites boîtes ou pochettes",
  "Confectionner des couronnes de Noël avec des branches, des baies et des rubans",
  "Peindre des cailloux pour en faire des petits personnages de Noël",
  "Fabriquer des marionnettes de doigts pour raconter des histoires de Noël",
  "Réaliser des étoiles en papier pour suspendre dans la maison",
  "Créer des flocons de neige en papier pour une décoration murale",
  "Fabriquer des masques de rennes ou de lutins pour jouer à se déguiser",
  "Confectionner des chaussettes de Noël en feutrine et les décorer",
  "Créer des décorations en origami pour le sapin ou pour suspendre",
  "Fabriquer des magnets de Noël avec des aimants et des images festives",
  "Réaliser des lanternes de Noël avec des pots de verre et des bougies LED",
  "Créer des marque-places pour la table de fête",
  "Confectionner des bonhommes de neige avec des chaussettes et du riz",
  "Fabriquer des couronnes de pommes de pin et les décorer",
  "Faire des oranges séchées au four pour décorer la maison",
  "Confectionner des bonhommes en pain d'épices en carton décoratif",
  "Fabriquer des décorations en feutrine à accrocher dans la maison",
  "Réaliser des boules de Noël personnalisées avec des photos ou des paillettes",
  "Créer des petits villages en carton pour une scène de Noël",
  "Fabriquer des cadeaux DIY pour offrir à ses proches (bougies, baumes à lèvres, etc.)",
];

export const hyggeListFR: string[] = [
  "Préparer du thé ou du chocolat chaud et le déguster en profitant d'un bon livre",
  "Créer un coin confortable avec des coussins, des couvertures et des bougies pour une soirée cocooning",
  "Faire une promenade en forêt ou dans un parc pour profiter de la nature hivernale",
  "Cuisiner un plat réconfortant et convivial à partager en famille ou entre amis",
  "Faire une séance de méditation ou de yoga pour se détendre et se recentrer",
  "Faire une photo de famille devant le sapin, accessoires et déguisements optionnels ou bienvenus",
  "Organiser un après-midi de jeux de société près du feu ou à la lueur des bougies",
  "Confectionner des décorations de Noël faites maison pour ajouter une touche personnelle à votre intérieur",
  "Prendre un bain relaxant avec des sels de bain parfumés et de la musique douce",
  "Préparer un plateau de dégustation de biscuits faits maison pour partager avec des proches",
  "Allumer des bougies parfumées et écouter de la musique apaisante pour créer une ambiance chaleureuse",
  "Créer une liste de gratitude pour réfléchir aux petites joies de la saison",
  "Fabriquer des cadeaux faits main pour offrir à vos proches",
  "Regarder les 'fails de Noël’ sur Youtube pour rigoler",
  "Écrire des lettres à des amis ou à la famille",
  "Faire une séance de peinture ou de coloriage relaxante pour libérer sa créativité",
  "Préparer un brunch copieux et profiter d'un moment de convivialité en famille",
  "Faire une séance de relaxation avec des exercices de respiration et de stretching",
  "Écouter un podcast ou une émission relaxante tout en s'occupant d'une activité manuelle",
  "Organiser un pique-nique intérieur avec des coussins et des couvertures douillettes",
  "Regarder un film ou une série douillette en famille ou en solo",
  "Faire une pause dans la journée pour déguster une tasse de thé ou de café en pleine conscience",
  "Créer une playlist de musique apaisante pour accompagner vos moments de détente",
  "Faire un tour dans le quartier pour admirer les décorations lumineuses de Noël",
  "Passer du temps de qualité avec vos proches, en partageant des moments simples mais précieux",
];
